import type { JSX } from "react";

import { newReportAction } from "../applicationBarActions";
import { ReportColumnId, REPORT_COLUMN_IDS } from "../columns";
import { ReportsListLayout } from "../layout";

function ReportsWorkloadPage(): JSX.Element {
    return (
        <ReportsListLayout
            pageType="Workload"
            columnIds={COLUMN_IDS}
            actions={[newReportAction("Workload")]}
        />
    );
}

const COLUMN_IDS: Array<ReportColumnId> = [
    REPORT_COLUMN_IDS.NAME,
    REPORT_COLUMN_IDS.DESCRIPTION,
    REPORT_COLUMN_IDS.PUSH_REPORTS_COUNT,
    REPORT_COLUMN_IDS.ACCESS_RIGHTS,
    REPORT_COLUMN_IDS.ACTION,
];

export { ReportsWorkloadPage };
